export default "__VITE_ASSET__DnrQ6qQn__";